import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getCasinoListing() {
    try {
        const response = await serviceContext.get(`${ReportsURL}result/open/casino`, null, options); // + "casinolisting/" + userId, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getCasinoBets(competitionId) {
    try {
        const response = await serviceContext.get(`${ReportsURL}bets/open/casino/${competitionId}`, null, options);  // + "casinobets/" + userId + "/" + competitionId, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};